"use client";
import React from "react";
import Link from "next/link";
import Separator from "../Common/Separator";
import EachBlogSection from "./EachBlogSection";
import { FaArrowRight } from "react-icons/fa6";
import BreadcrumbTwo from "../Common/BreadcrumbTwo";

export default function BlogPage({ allBlogs }) {
  const defaultView = 4;
  return (
    <div className="flex items-center justify-center">
      <div className="px-10 pt-36 sm:px-20">
        <div className="mb-5  flex flex-col  items-start justify-between gap-5 md:flex-row md:items-end ">
          <h1 className="text-4xl font-bold dark:text-gray-200">BLOGS</h1>
          <BreadcrumbTwo
            pages={[
              { pageName: "HOME", pageHref: "/" },
              {
                pageName: "BLOGS",
                pageHref: ``,
              },
            ]}
            className="h-fit w-fit"
          />
        </div>
        <Separator className="mt-7" />
        {allBlogs?.length === 0 ? (
          <div className="flex h-[40vh] w-full items-center justify-center text-xl font-semibold">
            No Blogs Found
          </div>
        ) : (
          <div className="flex flex-col gap-12 py-10">
            {allBlogs?.map((Blog, index) => {
              return (
                <div key={index} className="flex flex-col gap-8">
                  <EachBlogSection
                    Blog={Blog}
                    index={index}
                    defaultView={defaultView}
                  />
                  {Blog.blogList.length > defaultView && (
                    <Link
                      href={`blog/${Blog.categorySlug}/page/1`}
                      className="flex cursor-pointer items-center justify-end"
                    >
                      <div className="flex items-center justify-center gap-2 font-medium">
                        Browse More
                        <FaArrowRight />
                      </div>
                    </Link>
                  )}
                  {index !== allBlogs?.length - 1 && <Separator className="" />}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
